import React from "react";

const OfflineScreen = () => {
  const handleRetry = () => {
    if (navigator.onLine) {
      window.location.reload();
    }
  };

  return (
    <div style={{
      height: "100vh",
      backgroundColor: "#f7f8ff",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      padding: "20px",
    }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 24 24" style={{marginBottom:25}}>
            <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M21 19h-3m-4.5 0h-3M6 19H3M15.5 5l-8 8m8 0l-8-8" color="currentColor" />
        </svg>
      <h2 style={{ fontWeight: "bold", fontSize: "24px", marginBottom: "10px" }}>
        Error de conexión
      </h2>
      <p style={{ color: "#555", fontSize: "16px", marginBottom: "30px" }}>
        Parece que algo anda mal con tu internet.<br />
        Conéctate a internet para continuar utilizando la app
      </p>
      <button
        onClick={handleRetry}
        style={{
          backgroundColor: "#000",
          color: "#fff",
          border: "none",
          padding: "12px 24px",
          borderRadius: "8px",
          fontWeight: "bold",
          fontSize: "15px",
          cursor: "pointer",
        }}
      >
        REINTENTAR
      </button>
    </div>
  );
};

export default OfflineScreen;
